<script>
	import Tag from './tag.svelte'
	export let labels = [];

	let newtag = "";
	function addLabel(e) {
		newtag = newtag.trim();
		if (e.keyCode == 13 && newtag.length > 0) {
			labels = [...labels, newtag];
			newtag = "";
		}
	}
</script>

<div>
{#each labels as lbl}
	<Tag label={lbl} on:removeTag={e => labels = labels.filter(v => v != lbl)}/>
{/each}
<input bind:value={newtag} placeholder="štítek" list="tags" on:keypress={addLabel}/>
</div>
